(function () {
  'use strict';

  angular.module('app').component('packageContentsPage', packageContentListCtrl());

  function packageContentListCtrl() {
    return {
      bindings: {},
      controller: PackageContentListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/package-contents/package-contents-page.component.html',
    };
  }

  PackageContentListCtrl.$inject = [
    '$location',
    '$routeParams',
    'UtilService',
    'AbilityService',
    'SessionService',
    'PackageService',
    'PackageContentService',
    'LanguageService',

    // Angular downgraded service
    'ng2Router',
  ];

  function PackageContentListCtrl(
    $location,
    $routeParams,
    UtilService,
    AbilityService,
    SessionService,
    PackageService,
    PackageContentService,
    LanguageService,

    // Angular downgraded service
    ng2Router
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var companyWebsites = SessionService.getSelectedAccountCompany().websites;

    if (companyWebsites.length === 0) {
      vm.errorWebsites = true;
    }

    vm.permissions = {
      canCreate: AbilityService.can('create_package_accountadmin'),
    };

    vm.websiteId = $routeParams.WSID;
    vm.websiteName = vm.UtilService.findItemInArray(companyWebsites, 'id', vm.websiteId).name;
    vm.tabs = vm.UtilService.websiteTabs(vm.websiteId);

    // Methods
    vm.addPackageContent = addPackageContent;
    vm.onPackageContentShowed = onPackageContentShowed;

    vm.openPackageListModal = openPackageListModal;

    // Initializers
    getDefaultLanguage();
    // getPackagesContents();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getPackagesContents();
      });
    }

    function getPackagesContents() {
      vm.filterCriteria = PackageContentService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      PackageContentService.getPackagesContents(vm.websiteId, vm.filterCriteria).then(function (
        data
      ) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function addPackageContent() {
      $location.path(`/package_contents/new`).search({ WSID: vm.websiteId });
    }

    function onPackageContentShowed(item, mode) {
      $location.path(`/package_contents/${item.id}`).search({ WSID: vm.websiteId, mode: mode });
    }

    function openPackageListModal() {
      // var packageIds = [];

      // vm.items.forEach(function (content) {
      //   packageIds.push(content.package_id);
      // });

      PackageService.openPackageListModal(vm.websiteId);
    }

    vm.goToWebsiteDetail = (websiteId) => {
      ng2Router.navigate(['/ng/websites', websiteId]);
    };

    vm.goToWebsiteNew = () => {
      ng2Router.navigate(['/ng/websites/new']);
    };
  }
})();
